module.exports = __webpack_public_path__ + "img/fileIcon.edba1265.svg";